/**
 * OSProjectTemplateTDMImportShell - Shell component for OS TDM CSV Import
 *
 * This component wraps the TDM import functionality for OS routes.
 *
 * TODO: Create OS-specific ReviewContents component that uses OS API.
 * Currently, ReviewContents has embedded Sherpa API calls that need to be
 * refactored to accept API functions as props for full OS support.
 */

import { ArrowUpTrayIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import Button from '@/components/UI/Button';
import { CSVParserProvider } from '@/store/Context/CSVParserContext';
import { ReviewContents } from '../../Components/ProjectTemplateDetails/ProjectTemplateTDMImport/ReviewContents';
import { UploadModal } from '../../Components/ProjectTemplateDetails/ProjectTemplateTDMImport/UploadModal';

export const OSProjectTemplateTDMImportShell = () => {
  const [showUploadModal, setShowUploadModal] = useState<boolean>(false);

  const toggleModal = () => {
    setShowUploadModal((prev) => !prev);
  };

  // TODO: Create OS-specific ReviewContents or refactor existing to accept API props
  return (
    <CSVParserProvider>
      <Button btnStyle='btn-primary' type='button' label='Import from CSV' icon={<ArrowUpTrayIcon />} onClick={toggleModal} />
      <ReviewContents />
      {showUploadModal && <UploadModal onHide={toggleModal} />}
    </CSVParserProvider>
  );
};

export default OSProjectTemplateTDMImportShell;
